import {Loader2} from "lucide-react";

interface SpinnerProps {

}

export function Spinner(props: SpinnerProps) {
    return (
            <div className="flex items-center justify-center">
                <Loader2 className={'animate-spin'}/>
            </div>
    )
}

Spinner.displayName = "Spinner";
